import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {LevelAssessmentButtonStatus} from "~~/package/mapper/levelAssessment/model/LevelAssessmentButtonStatus";

export class LevelAssessmentButtonStatusModel extends Model {
    constructor(
        public startBtnStatus: LevelAssessmentButtonStatus = LevelAssessmentButtonStatus.START_ASSESSMENT_BTN_NON_EXPOSED,
        public retakeBtnStatus: LevelAssessmentButtonStatus = LevelAssessmentButtonStatus.RETAKE_BTN_NON_EXPOSED,
        public seeAnswerBtnStatus: LevelAssessmentButtonStatus = LevelAssessmentButtonStatus.SEE_ANSWER_BTN_NON_EXPOSED
    ) {
        super();
    }

    public static create(model: Partial<LevelAssessmentButtonStatusModel>): LevelAssessmentButtonStatusModel {
        return createModel<LevelAssessmentButtonStatusModel>(LevelAssessmentButtonStatusModel, {
            ...model
        });
    }
}
